import React, { useEffect, useState } from "react";
import "../../css/Dashboard.css";
import "../../css/Form.css";
import FirstRound from "./status/FirstRound";
import SecondRound from "./status/SecondRound";
import ThirdRound from './status/ThirdRound';
import ApplicationPreview from "./preview/ApplicationPreview";
import SelectedForm from "./status/selectedForm";
import useStateCallback from "../../helper/asyncSetState.ts";
import ApiGateway from "../../helper/ApiGateway";
import Loader from "../../helper/Loader";
import Popup from "../../helper/SuccessPopup";
import ERPUtils from "../../helper/Utils";
import Dialog from "@mui/material/Dialog";
import { Card, CardContent, DialogContent, Typography } from "@mui/material";
import InterviewScheduleDetails from "./status/InterviewDetails";

const Dashboard = (props) => {
  const { ApplyNewHandler, openPendingApplication, ApplicationsPrevData, checkApplications, jobCode } = props;
  // Component State start:
  const [interviewDetails, setInterviewDetails] = useStateCallback({
    date: "",
    time: "",
    venue: "",
    pointOfContact: "",
    editable: true,
    reportingTime: "",
    venueLink: null,
  });

  const [workFlow, setWorkFlow] = useState("")
  const [savedData, setSavedData] = useStateCallback(null);

  const [refreshFlag, setRefreshFlag] = useState(false)

  // Active comp State:
  const [CompState, setCompState] = useState({
    FirstRound: false,
    SecondRound: false,
    ThirdRound: false,
    selected: false,
  });
  // const [ ApplicationsData, setApplicationsData ] = useState(ApplicationsPrevData);
  const [selectedRoundData, setSelectedRoundData] = useStateCallback(null);
  // Popup state:
  const [ModalOpen, setModalOpen] = useState(false); // For showing preview.
  const [previewData, setPreviewData] = useStateCallback({});
  const [ApiError, setApiError] = useState(false);
  const [interviewModal, setInterviewModal] = useStateCallback(false);
  const [ActiveInterviewRound, setActiveInterviewRound] = useState(null);
  //Loader:
  const [LoaderActive, setLoaderActive] = useState(false);

  const [archiveMsg, setArchivedMsg] = useState(false)

  // Component State End:

  // State Handlers:

  // const showInterviewRounds = () => {
  //   var oldObj = { ...CompState };
  //   Object.keys(oldObj).map((el) => {
  //     if (el === target) {
  //       oldObj[el] = true;
  //     } else {
  //       oldObj[el] = false;
  //     }
  //     return '';
  //   });
  //   setCompState(oldObj);
  // }
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant" // or "smooth"
    });
  }, []);




  const RenderActiveComp = (data, isShow) => {
    setActiveInterviewRound(data);
    var oldObj = { ...CompState };
    var target =
      data.interviewRound === '1'
        ? 'FirstRound'
        : data.interviewRound === '2' ? 'SecondRound' : data.interviewRound === '3' ? 'ThirdRound'
          : data.interviewRound === 'selected' ? 'selected' : null;
    Object.keys(oldObj).map((el) => {
      if (el === target) {
        oldObj[el] = true;
      } else {
        oldObj[el] = false;
      }
      return '';
    });
    setCompState(oldObj);
    if (isShow) {
      setInterviewModal(true);
    }
  };

  const ChangeTheState = (data, edit) => {
    let oldObj = { ...interviewDetails };
    if (data !== null) {
      // oldObj["date"] = data.interviewDateTime !== undefined ? data.interviewDateTime.split(" ")[0] : "";
      oldObj["date"] = data.interviewDateTime1 !== undefined ? data.interviewDateTime1 : null;
      // oldObj["time"] = data.interviewDateTime !== undefined ? data.interviewDateTime.split(" ")[1] + " " + data.interviewDateTime.split(" ")[2] : "";
      oldObj["venue"] = data.interviewVenue !== undefined ? data.interviewVenue : "";
      oldObj["pointOfContact"] = data.pointOfContactUsersId !== undefined ? data.pointOfContactUsersId : "";
      oldObj["editable"] = edit;
      oldObj["venueLink"] = !ERPUtils.isNullOrEmpty(data.venueLink) ? data.venueLink : null

      oldObj["reportingTime"] = data.reportingTime !== undefined ? data.reportingTime : null;
    }
    setWorkFlow(data.applicationStatusCode)
    setInterviewDetails(oldObj);
  };

  // To open the preview modal
  const openModal = () => {
    setModalOpen(true);
  };

  // To close the Dialog:
  const handleClose = () => {
    setModalOpen(false);
  };

  const getDob = (date) => {
    if (!ERPUtils.isUndefinedOrNull(date)) {
      const parts = date.split("/");
      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const newDate = `${parts[0]}-${months[Number(parts[1]) - 1]}-${parts[2]}`;
      return newDate;
    }
    return "";
  };

  const refreshWindowCell = () => {
    window.location.reload();
  }


  // To Close the error popup
  const closeErrorPopup = () => {
    setApiError(false);
  };

  // To close the interview modal handler:
  const closeInterviewModal = () => {
    let oldObj = { ...CompState };
    Object.keys(oldObj).map((el) => {
      oldObj[el] = false;
      return "";
    });
    setCompState(oldObj);
    setInterviewModal(false);
    clearState();
  };

  const clearState = () => {
    setInterviewDetails({
      date: "",
      time: "",
      venue: "",
      pointOfContact: "",
      editable: true,
    });
    setSavedData(null);
    setSelectedRoundData(null);
  };

  // Api handlers Start ---->
  // Api Handler for showing the preview data:
  const loadThePreviewData = (openApplNo) => {
    setLoaderActive(true);
    let url = "Employee/Recruitment/EmployeeApplicationControler/getEmployeeApplicationPreview?applicationNo=";
    ApiGateway.post(url + openApplNo, {}, (response) => {
      try {
        setLoaderActive(false);
        if (ERPUtils.isUndefinedOrNull(response) === false) {
          try {
            if (response.data.success === true) {
              setPreviewData(response.data.dto, () => {
                openModal();
              });
            } else {
              setLoaderActive(false);
              setApiError(true);
            }
          } catch (ex) { }
        }
      } catch (ex) {
        setLoaderActive(false);
        setApiError(true);
      }
    });
  };


  const ischeck = (data) => {
    if (data.applicationStatusCode === "EMP_STAGE1_PO_APPROVES_SCHEDULE" || data.applicationStatusCode === "EMP_STAGE1_HOD_RESCHEDULED" ||
      data.applicationStatusCode === "EMP_STAGE2_PO_SCHEDULED" || data.applicationStatusCode === "EMP_STAGE2_PO_RESCHEDULED" ||
      data.applicationStatusCode === "EMP_STAGE3_PO_SCHEDULED" || data.applicationStatusCode === "EMP_STAGE3_PO_RESCHEDULED"
    ) {
      return true;
    } else {
      return false
    }
  }


  const showVenueDetails = (data, edit) => {
    setLoaderActive(true);
    let url = "Employee/CommonEmployee/getApplnInterviewScheduleDetails?empApplnEntriesId=";
    ApiGateway.post(url + data?.identityRow + "&interviewRound=" + data.interviewRound, {}, (response) => {
      try {
        setLoaderActive(false);
        if (ERPUtils.isUndefinedOrNull(response) === false) {
          try {
            if (response.data.success === true) {
              ChangeTheState(response.data.dto, edit);
              RenderActiveComp(data, false);
              setIsShowVenue(true)
            } else {
              setLoaderActive(false);
            }
          } catch (ex) { }
        }
      } catch (ex) {
        setLoaderActive(false);
      }
    });
  }




  // Api handler for to get the interview details:
  const CallRoundDetailsApi = (data, edit, event) => {
    setLoaderActive(true);
    let url = "Employee/CommonEmployee/getApplnInterviewScheduleDetails?empApplnEntriesId=";
    ApiGateway.post(url + data?.identityRow + "&interviewRound=" + data.interviewRound, {}, (response) => {
      try {
        setLoaderActive(false);
        if (ERPUtils.isUndefinedOrNull(response) === false) {
          try {
            if (response.data.success === true) {
              ChangeTheState(response.data.dto, edit);
              RenderActiveComp(data, true);
              if (ischeck(response.data.dto)) {
                setRefreshFlag(false)
              } else {
                setRefreshFlag(true)
              }
            } else {
              setLoaderActive(false);
              setApiError(true);
            }
          } catch (ex) { }
        }
      } catch (ex) {
        setLoaderActive(false);
        setApiError(true);
      }
    });
  };





  const isShowInterviewDetails = (data) => {  //Based on this workflow we added extra link to edit additional information by user..
    if ((data.applicantProcessCode === "EMP_STAGE1_APPLICANT_ACCEPTED"
      || data.applicantProcessCode === "EMP_STAGE1_SELECTED"
      || data.applicantProcessCode === "EMP_STAGE1_BYPASSED"
      || data.applicantProcessCode === "EMP_STAGE1_HOD_RESCHEDULED") && (
        data.applicationProcessCode === "EMP_STAGE1_APPLICANT_ACCEPTED"
        || data.applicationProcessCode === "EMP_STAGE1_SELECTED"
        || data.applicationProcessCode === "EMP_STAGE1_BYPASSED"
        || data.applicationProcessCode === "EMP_STAGE1_HOD_RESCHEDULED")) {
      return true;
    }
    if ((data.applicantProcessCode === "EMP_STAGE2_SCHEDULE_APPLICANT_ACCEPTED" ||
      data.applicantProcessCode === "EMP_STAGE2_SELECTED" ||
      data.applicantProcessCode === "EMP_STAGE2_PO_RESCHEDULED")
      && (data.applicationProcessCode === "EMP_STAGE2_SCHEDULE_APPLICANT_ACCEPTED" ||
        data.applicationProcessCode === "EMP_STAGE2_SELECTED" ||
        data.applicationProcessCode === "EMP_STAGE2_PO_RESCHEDULED")) {
      return true;
    } else {
      return false;
    }
  }

  const isCheck2 = (data) => {
    if (data.applicantWorkFlowStatusCode === "EMP_STAGE2_PO_SCHEDULED" || data.applicantWorkFlowStatusCode === "EMP_STAGE3_PO_SCHEDULED") {
      return true;
    } else {
      return false;
    }
  }

  const [isShowVenue, setIsShowVenue] = useState(false)

  //  const []
  // get the saved data
  const getSavedData = (data, edit) => { // isShowInterviewDetails() funtion returns true or false...if it is true we are calling researchdata to get additional information 
    const url = !isShowInterviewDetails(data) ? "Employee/Recruitment/EmployeeApplicationControler/getEmployeeApplicaltionInterviewDetails?empApplnEntriesId=" + data.identityRow + "&interviewRound=" + data.interviewRound :
      "Employee/Recruitment/EmployeeApplicationControler/getEmployeeResearchData?empApplnEntriesId=" + data.empApplnEntriesId    // let url = "Employee/Recruitment/EmployeeApplicationControler/getEmployeeApplicaltionInterviewDetails?empApplnEntriesId=";
    if (data.applicationProcessCode === "EMPLOYEE_APPLICATION_ARCHIVED") {
      setArchivedMsg(true)
    } else {
      setLoaderActive(true);
      ApiGateway.post(url, {}, (response) => {
        try {
          setLoaderActive(false);
          if (ERPUtils.isUndefinedOrNull(response) === false) {
            try {
              if (response.status === "SUCCESS") {
                setSavedData(response.data.dto, () => {
                  RenderActiveComp(data, true)
                  if (isCheck2(response.data.dto)) {
                    setRefreshFlag(true)
                  } else {
                    setRefreshFlag(false)
                  }
                  // CallRoundDetailsApi(data, edit);
                });
              } else {
                setLoaderActive(false);
                setApiError(true);
              }
            } catch (ex) { }
          }
        } catch (ex) {
          setLoaderActive(false);
          setApiError(true);
        }
      });
    }
  };

  // get the applications
  const getApplicationsData = () => {
    closeInterviewModal();
    checkApplications();
  };

  const SelectedRoundData = (data, edit) => {
    let url = "Employee/Recruitment/EmployeeApplicationControler/getEmployeeApplicationInterviewDetails?empApplnEntriesId=";
    setLoaderActive(true);
    ApiGateway.post(url + data.identityRow + "&interviewRound=selected", {}, (response) => {
      try {
        setLoaderActive(false);
        if (ERPUtils.isUndefinedOrNull(response) === false) {
          try {
            if (response.status === "SUCCESS") {
              setSelectedRoundData(response.data.dto, () => {
                // CallRoundDetailsApi(data, edit);
                data.interviewRound = "selected";
                RenderActiveComp(data, true);
                ChangeTheState({}, edit);
              });
            } else {
              setLoaderActive(false);
              setApiError(true);
            }
          } catch (ex) { }
        }
      } catch (ex) {
        setLoaderActive(false);
        setApiError(true);
      }
    });
  };

  // Api handlers End---->

  return (
    <div className="dashBoardMainDiv">
      <div className="dashoardHeader">
        <h3 className="dashboardHeaderText">Applicant View</h3>
        <button className="applyButton pull-right" value="Apply Here" name="ApplyNew" onClick={ApplyNewHandler}>
          Apply Here
        </button>
      </div>

      <div className="applicant-mobile-view" style={{ height: window.innerWidth > 800 ? window.innerHeight - 255 : window.innerWidth <= 375 ? window.innerHeight - 275 : window.innerWidth <= 425 ? window.innerHeight - 260 : window.innerHeight - 260, overflowY: "auto" }}>
        {window.innerWidth <= 768 ? (
          ApplicationsPrevData.map((el, index) => (
            <Card key={index} className="p-1 mt-2" sx={{ minWidth: 250, maxHeight: 250 }}>
              <CardContent>
                <Typography color="textSecondary" gutterBottom>
                  <div> Submission Date:</div>
                  <div> {el.submissionDate ? el.submissionDate.split(" ")[0] : "-"} </div>
                </Typography>
                <Typography color="textSecondary" gutterBottom>
                  <div>Application No:</div>
                  <div>
                    {el.applicationNo ? (
                      <span
                        className="link link-primary emp-appl-custom-link"
                        onClick={() => loadThePreviewData(el.identityRow)}
                        tabIndex={0}
                        onKeyDown={(e) => {
                          if (e.key !== "Tab" && ERPUtils.isKeyBoardEnterPressed(e)) {
                            loadThePreviewData(el.identityRow);
                          }
                        }}
                      >
                        {el.applicationNo}
                      </span>
                    ) : (
                      "-"
                    )}
                  </div>
                </Typography>
                <Typography color="textSecondary" gutterBottom>
                  <div>Advertisement No</div>
                  <div>
                    {el.advertisementNo || ""}
                  </div>
                </Typography>
                <Typography color="textSecondary">
                  <div>  Status:{" "}</div>
                  <div>
                    {el.applicantCurrentProcessStatus === "saveDraft" ? (
                      <span
                        className="link link-primary emp-appl-custom-link"
                        name="status"
                        onClick={() => openPendingApplication(el.identityRow)}
                        tabIndex={0}
                        role="button"
                        onKeyDown={(e) => {
                          if (e.key !== "Tab" && ERPUtils.isKeyBoardEnterPressed(e)) {
                            openPendingApplication(el.identityRow);
                          }
                        }}
                      >
                        Your application submission is incomplete. Click here to complete.
                      </span>
                    ) : (
                      <>
                        <span
                          className={el.applicantProcessCode === "EMP_STAGE1_PO_APPROVES_SCHEDULE" || el.applicantProcessCode === "EMP_STAGE1_HOD_RESCHEDULED" || el.applicantProcessCode === "EMP_STAGE2_PO_SCHEDULED" || el.applicantProcessCode === "EMP_STAGE2_PO_RESCHEDULED" ||
                            el.applicantProcessCode === "EMP_STAGE3_PO_SCHEDULED" || el.applicantProcessCode === "EMP_STAGE3_PO_RESCHEDULED" || el.applicantProcessCode === "EMP_STAGE3_SELECTED" || el.applicantProcessCode === "EMP_OFFER_LETTER_GENERATED" || el.applicantProcessCode === "EMP_OFFER_LETTER_REGENERATE" || el.applicantProcessCode === "EMP_OFFER_ACCEPTED" ? "link link-primary emp-appl-custom-link" : "text-bold"}
                          name="status"
                          onClick={() => {
                            if (el.applicantProcessCode === "EMP_STAGE1_PO_APPROVES_SCHEDULE" || el.applicantProcessCode === "EMP_STAGE1_HOD_RESCHEDULED") {
                              if (el.applicationProcessCode === "EMP_STAGE1_PO_APPROVES_SCHEDULE" || el.applicationProcessCode === "EMP_STAGE1_HOD_RESCHEDULED") {
                                CallRoundDetailsApi(el, true);
                              } else {
                                getSavedData(el, false);
                              }
                            } else if (el.applicantProcessCode === "EMP_STAGE2_PO_SCHEDULED" || el.applicantProcessCode === "EMP_STAGE2_PO_RESCHEDULED") {
                              if (el.applicationProcessCode === "EMP_STAGE2_PO_SCHEDULED" || el.applicationProcessCode === "EMP_STAGE2_PO_RESCHEDULED") {
                                CallRoundDetailsApi(el, true);
                              } else {
                                getSavedData(el, false);
                              }
                            } else if (el.applicantProcessCode === "EMP_STAGE3_PO_SCHEDULED" || el.applicantProcessCode === "EMP_STAGE3_PO_RESCHEDULED") {
                              if (el.applicationProcessCode === "EMP_STAGE3_PO_SCHEDULED" || el.applicationProcessCode === "EMP_STAGE3_PO_RESCHEDULED") {
                                CallRoundDetailsApi(el, true);
                              } else {
                                getSavedData(el, false);
                              }
                            } else if (
                              el.applicantProcessCode === "EMP_STAGE3_SELECTED" ||
                              el.applicantProcessCode === "EMP_OFFER_LETTER_GENERATED" ||
                              el.applicantProcessCode === "EMP_OFFER_LETTER_REGENERATE" ||
                              el.applicantProcessCode === "EMP_OFFER_ACCEPTED"
                            ) {
                              if (el.applicationProcessCode === "EMP_STAGE3_SELECTED" || el.applicationProcessCode === "EMP_OFFER_LETTER_REGENERATE" || el.applicationProcessCode === "EMP_OFFER_LETTER_GENERATED" || el.applicantProcessCode === "EMP_OFFER_ACCEPTED") {
                                SelectedRoundData(el, true);
                              }
                              //  else {
                              //   SelectedRoundData(el, true);
                              // }
                            }
                          }}
                          tabIndex={0}
                          onKeyDown={(e) => {
                            if (e.key !== "Tab" && ERPUtils.isKeyBoardEnterPressed(e)) {
                              if (el.applicantProcessCode === "EMP_STAGE1_PO_APPROVES_SCHEDULE" || el.applicantProcessCode === "EMP_STAGE1_HOD_RESCHEDULED") {
                                if (el.applicationProcessCode === "EMP_STAGE1_PO_APPROVES_SCHEDULE" || el.applicationProcessCode === "EMP_STAGE1_HOD_RESCHEDULED") {
                                  CallRoundDetailsApi(el, true);
                                } else {
                                  getSavedData(el, false);
                                }
                              } else if (el.applicantProcessCode === "EMP_STAGE2_PO_SCHEDULED" || el.applicantProcessCode === "EMP_STAGE2_PO_RESCHEDULED") {
                                if (el.applicationProcessCode === "EMP_STAGE2_PO_SCHEDULED" || el.applicationProcessCode === "EMP_STAGE2_PO_RESCHEDULED") {
                                  CallRoundDetailsApi(el, true);
                                } else {
                                  getSavedData(el, false);
                                }
                              } else if (el.applicantProcessCode === "EMP_STAGE3_PO_SCHEDULED" || el.applicantProcessCode === "EMP_STAGE3_PO_RESCHEDULED") {
                                if (el.applicationProcessCode === "EMP_STAGE3_PO_SCHEDULED" || el.applicationProcessCode === "EMP_STAGE3_PO_RESCHEDULED") {
                                  CallRoundDetailsApi(el, true);
                                } else {
                                  getSavedData(el, false);
                                }
                              } else if (
                                el.applicantProcessCode === "EMP_STAGE3_SELECTED" ||
                                el.applicantProcessCode === "EMP_OFFER_LETTER_GENERATED" ||
                                el.applicantProcessCode === "EMP_OFFER_LETTER_REGENERATE" ||
                                el.applicantProcessCode === "EMP_OFFER_ACCEPTED"
                              ) {
                                if (el.applicationProcessCode === "EMP_STAGE3_SELECTED" || el.applicationProcessCode === "EMP_OFFER_LETTER_REGENERATE" || el.applicationProcessCode === "EMP_OFFER_LETTER_GENERATED" || el.applicantProcessCode === "EMP_OFFER_ACCEPTED") {
                                  SelectedRoundData(el, true);
                                }
                                // else {
                                //   SelectedRoundData(el, false);
                                // }
                              }
                            }
                          }}
                        >
                          {el.applicantCurrentProcessStatus}
                        </span>
                        {el.applicantProcessCode === "EMP_STAGE1_APPLICANT_ACCEPTED" ||
                          el.applicantProcessCode === "EMP_STAGE1_SELECTED" ||
                          el.applicantProcessCode === "EMP_STAGE1_BYPASSED" ||
                          el.applicantProcessCode === "EMP_STAGE1_HOD_RESCHEDULED" || el.applicantProcessCode === "EMP_STAGE2_SCHEDULE_APPLICANT_ACCEPTED" ||
                          el.applicantProcessCode === "EMP_STAGE2_SELECTED" ||
                          el.applicantProcessCode === "EMP_STAGE2_PO_RESCHEDULED" ? (
                          (el.applicationProcessCode === "EMP_STAGE1_APPLICANT_ACCEPTED" ||
                            el.applicationProcessCode === "EMP_STAGE1_SELECTED" ||
                            el.applicationProcessCode === "EMP_STAGE1_BYPASSED"
                            || el.applicationProcessCode === "EMP_STAGE1_HOD_RESCHEDULED" || el.applicantProcessCode === "EMP_STAGE2_SCHEDULE_APPLICANT_ACCEPTED" ||
                            el.applicantProcessCode === "EMP_STAGE2_SELECTED" ||
                            el.applicantProcessCode === "EMP_STAGE2_PO_RESCHEDULED" || el.applicationProcessCode === "EMPLOYEE_APPLICATION_ARCHIVED") ? (
                            <div
                              className={
                                (el.applicantProcessCode === "EMP_STAGE1_APPLICANT_ACCEPTED" ||
                                  el.applicantProcessCode === "EMP_STAGE1_SELECTED" ||
                                  el.applicantProcessCode === "EMP_STAGE1_BYPASSED" ||
                                  el.applicantProcessCode === "EMP_STAGE1_HOD_RESCHEDULED" || el.applicationProcessCode === "EMPLOYEE_APPLICATION_ARCHIVED" ||
                                  el.applicantProcessCode === "EMP_STAGE2_SCHEDULE_APPLICANT_ACCEPTED" ||
                                  el.applicantProcessCode === "EMP_STAGE2_SELECTED" || el.applicantProcessCode === "EMP_STAGE2_PO_RESCHEDULED")
                                && "link link-primary emp-appl-custom-link"
                              }
                              onClick={() => {
                                if (
                                  el.applicantProcessCode === "EMP_STAGE1_APPLICANT_ACCEPTED" ||
                                  el.applicantProcessCode === "EMP_STAGE1_SELECTED" ||
                                  el.applicantProcessCode === "EMP_STAGE1_BYPASSED" || el.applicantProcessCode === "EMP_STAGE1_HOD_RESCHEDULED"
                                ) {
                                  if (el.applicationProcessCode === "EMP_STAGE1_APPLICANT_ACCEPTED" ||
                                    el.applicationProcessCode === "EMP_STAGE1_SELECTED" ||
                                    el.applicationProcessCode === "EMP_STAGE1_BYPASSED" || el.applicantProcessCode === "EMP_STAGE1_HOD_RESCHEDULED" || el.applicationProcessCode === "EMPLOYEE_APPLICATION_ARCHIVED") {
                                    getSavedData(el, true)
                                  }
                                } else if (
                                  el.applicantProcessCode === "EMP_STAGE2_SCHEDULE_APPLICANT_ACCEPTED" ||
                                  el.applicantProcessCode === "EMP_STAGE2_SELECTED" || el.applicantProcessCode === "EMP_STAGE2_PO_RESCHEDULED"
                                ) {
                                  if (el.applicationProcessCode === "EMP_STAGE2_SCHEDULE_APPLICANT_ACCEPTED" ||
                                    el.applicationProcessCode === "EMP_STAGE2_SELECTED" || el.applicantProcessCode === "EMP_STAGE2_PO_RESCHEDULED" || el.applicationProcessCode === "EMPLOYEE_APPLICATION_ARCHIVED") {
                                    getSavedData(el, true)
                                  }
                                }
                              }}>
                              Click here to fill additional information to application
                            </div>
                          ) : ("")
                        ) : ("")}
                      </>
                    )}
                  </div>
                </Typography>
              </CardContent>
            </Card>
          ))
        ) : (
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Submission Date</th>
                  <th scope="col">Application No.</th>
                  <th scope="col">Advertisement No.</th>

                  <th scope="col" colSpan={4}>
                    Status
                  </th>
                </tr>
              </thead>
              <tbody>
                {ApplicationsPrevData.map((el, index) => {
                  return (
                    <tr key={index}>
                      <th>{index + 1}</th>
                      <td>{ERPUtils.isNullorWhiteSpace(el.submissionDate) === false ? el.submissionDate.split(" ")[0] : "-"}</td>
                      <td>
                        {el.applicationNo !== (null && undefined) ? (
                          <p
                            className="link link-primary emp-appl-custom-link"
                            onClick={loadThePreviewData.bind(this, el.identityRow)}
                            tabIndex={0}
                            onKeyDown={(e) => {
                              if (e.key !== "Tab" && ERPUtils.isKeyBoardEnterPressed(e)) loadThePreviewData(el.identityRow);
                            }}
                          >
                            {el.applicationNo}
                          </p>
                        ) : (
                          "-"
                        )}
                      </td>
                      <td>
                        {el.advertisementNo || ""}
                      </td>
                      <td>
                        {el.applicantProcessCode === "EMP_STAGE1_PO_APPROVES_SCHEDULE" ?
                          (
                            el.applicationProcessCode === "EMP_STAGE1_PO_APPROVES_SCHEDULE" ? (
                              <span
                                className="link link-primary emp-appl-custom-link "
                                name="status"
                                onClick={CallRoundDetailsApi.bind(this, el, true)}
                                tabIndex={0}
                                onKeyDown={(e) => {
                                  if (e.key !== "Tab" && ERPUtils.isKeyBoardEnterPressed(e)) CallRoundDetailsApi(el, true);
                                }}
                              >
                                {el.applicantCurrentProcessStatus}
                              </span>
                            ) : (
                              <span
                                className="link link-primary emp-appl-custom-link"
                                name="status"
                                onClick={getSavedData.bind(this, el, false)}
                                tabIndex={0}
                                onKeyDown={(e) => {
                                  if (e.key !== "Tab" && ERPUtils.isKeyBoardEnterPressed(e)) getSavedData(el);
                                }}
                              >
                                {el.applicantCurrentProcessStatus}
                              </span>
                            )
                          )
                          : el.applicantProcessCode === "EMP_STAGE2_PO_SCHEDULED" ?
                            (
                              el.applicationProcessCode === "EMP_STAGE2_PO_SCHEDULED" ?
                                (
                                  <span
                                    className="link link-primary emp-appl-custom-link"
                                    name="status"
                                    onClick={CallRoundDetailsApi.bind(this, el, true)}
                                    // onClick={getSavedData.bind(this, el, true)}
                                    tabIndex={0}
                                    onKeyDown={(e) => {
                                      if (e.key !== "Tab" && ERPUtils.isKeyBoardEnterPressed(e)) CallRoundDetailsApi(el, true);
                                    }}
                                  // onKeyDown={(e) => {
                                  //   if (e.key !== "Tab" && ERPUtils.isKeyBoardEnterPressed(e)) getSavedData(el, true);
                                  // }}
                                  >
                                    {el.applicantCurrentProcessStatus}
                                  </span>
                                ) : (
                                  <span className="link link-primary emp-appl-custom-link" name="status" onClick={getSavedData.bind(this, el, false)} tabIndex={0}>
                                    {el.applicantCurrentProcessStatus}
                                  </span>
                                )
                            )
                            // : el.applicantProcessCode === "EMP_STAGE3_PO_SCHEDULED " || el.applicantProcessCode === "EMP_STAGE3_PO_RESCHEDULED" ? (
                            //   el.applicationProcessCode === "EMP_STAGE3_PO_SCHEDULED " || el.applicationProcessCode === "EMP_STAGE3_PO_RESCHEDULED" ? (
                            //     <span
                            //       className="link link-primary emp-appl-custom-link"
                            //       name="status"
                            //       onClick={CallRoundDetailsApi.bind(this, el, true)}
                            //       tabIndex={0}
                            //       onKeyDown={(e) => {
                            //         if (e.key !== "Tab" && ERPUtils.isKeyBoardEnterPressed(e)) CallRoundDetailsApi(el, true);
                            //       }}
                            //     >
                            //       {el.applicantCurrentProcessStatus}
                            //     </span>
                            //      ) : (
                            //     <span className="link link-primary emp-appl-custom-link" name="status" onClick={getSavedData.bind(this, el, false)} tabIndex={0}>
                            //       {el.applicantCurrentProcessStatus}
                            //     </span>
                            //    )
                            //   )
                            : el.applicantProcessCode === "EMP_STAGE3_PO_SCHEDULED" || el.applicantProcessCode === "EMP_STAGE3_PO_RESCHEDULED" ? (
                              el.applicationProcessCode === "EMP_STAGE3_PO_SCHEDULED" || el.applicationProcessCode === "EMP_STAGE3_PO_RESCHEDULED" ? (
                                <span
                                  className="link link-primary emp-appl-custom-link"
                                  name="status"
                                  onClick={CallRoundDetailsApi.bind(this, el)}
                                  tabIndex={0}
                                  onKeyDown={(e) => {
                                    if (e.key !== "Tab" && ERPUtils.isKeyBoardEnterPressed(e))
                                      CallRoundDetailsApi(el);
                                  }}
                                >
                                  {el.applicantCurrentProcessStatus}
                                </span>
                              ) : (
                                <span
                                  className="link link-primary emp-appl-custom-link"
                                  name="status"
                                  onClick={getSavedData.bind(this, el, false)}
                                  tabIndex={0}
                                >
                                  {el.applicantCurrentProcessStatus}
                                </span>
                              )
                            )

                              :
                              el.applicantProcessCode === "EMP_STAGE3_SELECTED" ||
                                el.applicantProcessCode === "EMP_OFFER_LETTER_GENERATED" ||
                                el.applicantProcessCode === "EMP_OFFER_LETTER_REGENERATE" ||
                                el.applicantProcessCode === "EMP_OFFER_ACCEPTED" ||
                                el.applicantProcessCode === "EMP_OFFER_ACCEPTED" ? (
                                el.applicationProcessCode === "EMP_STAGE3_SELECTED" ||
                                  el.applicationProcessCode === "EMP_OFFER_LETTER_GENERATED" ||
                                  el.applicationProcessCode === "EMP_OFFER_LETTER_REGENERATE" ? (
                                  <>


                                    <span
                                      className="link link-primary emp-appl-custom-link"
                                      name="status"
                                      onClick={SelectedRoundData.bind(this, el, true)}
                                      tabIndex={0}
                                      onKeyDown={(e) => {
                                        if (e.key !== "Tab" && ERPUtils.isKeyBoardEnterPressed(e)) SelectedRoundData(el, true);
                                      }}
                                    >
                                      {el.applicantCurrentProcessStatus}
                                    </span>
                                  </>
                                ) : (
                                  <span
                                    className="link link-primary emp-appl-custom-link"
                                    name="status"
                                    onClick={SelectedRoundData.bind(this, el, true)}
                                    tabIndex={0}
                                    onKeyDown={(e) => {
                                      if (e.key !== "Tab" && ERPUtils.isKeyBoardEnterPressed(e)) SelectedRoundData(el, true);
                                    }}
                                  >
                                    {el.applicantCurrentProcessStatus}
                                  </span>
                                )
                              )
                                : el.applicantCurrentProcessStatus === "saveDraft" ? (
                                  <span
                                    className="link link-primary emp-appl-custom-link"
                                    name="status"
                                    onClick={openPendingApplication.bind(this, el.identityRow)}
                                    tabIndex={0}
                                    role="button"
                                    onKeyDown={(e) => {
                                      if (e.key !== "Tab" && ERPUtils.isKeyBoardEnterPressed(e)) openPendingApplication(el.identityRow);
                                    }}
                                  >
                                    Your application submission is incomplete, Click here to complete.
                                    {/* save draft */}
                                  </span>
                                )
                                  :
                                  el.applicantProcessCode === "EMP_STAGE1_APPLICANT_ACCEPTED" ||
                                    el.applicantProcessCode === "EMP_STAGE1_SELECTED" ||
                                    el.applicantProcessCode === "EMP_STAGE1_BYPASSED" ? (
                                      el.applicationProcessCode === "EMP_STAGE1_APPLICANT_ACCEPTED" ||
                                      el.applicationProcessCode === "EMP_STAGE1_SELECTED" ||
                                      el.applicationProcessCode === "EMP_STAGE1_BYPASSED" || el.applicationProcessCode === "EMPLOYEE_APPLICATION_ARCHIVED"
                                    ) && (
                                    <>
                                      <p>{el.applicantCurrentProcessStatus}</p>
                                      {el.applicantProcessCode === "EMP_STAGE1_APPLICANT_ACCEPTED" && (
                                        <>
                                          <div className="mt-2 ">
                                            <label>Venue and Contact Details</label> : {" "}
                                            <span
                                              className="link link-primary emp-appl-custom-link"
                                              name="status"
                                              onClick={showVenueDetails.bind(this, el, true)}
                                              tabIndex={0}
                                              onKeyDown={(e) => { }}
                                            >
                                              View Venue & Contact Details
                                            </span>
                                          </div>
                                          <lable>Action Required </lable> : {" "}
                                        </>
                                      )}
                                      <span
                                        className="link link-primary emp-appl-custom-link"
                                        name="status"
                                        onClick={getSavedData.bind(this, el, true)}
                                        tabIndex={0}
                                        onKeyDown={(e) => {
                                          if (e.key !== "Tab" && ERPUtils.isKeyBoardEnterPressed(e)) getSavedData(el, true);
                                        }}
                                      >
                                        Click here to fill additional information to application
                                      </span>
                                    </>
                                  )
                                    :
                                    el.applicantProcessCode === "EMP_STAGE2_SCHEDULE_APPLICANT_ACCEPTED" ||
                                      el.applicantProcessCode === "EMP_STAGE2_SELECTED" ? (
                                        el.applicationProcessCode === "EMP_STAGE2_SCHEDULE_APPLICANT_ACCEPTED" ||
                                        el.applicationProcessCode === "EMP_STAGE2_SELECTED" || el.applicationProcessCode === "EMPLOYEE_APPLICATION_ARCHIVED"
                                      ) && (
                                      <>
                                        <p>{el.applicantCurrentProcessStatus}</p>
                                        {el.applicantProcessCode === "EMP_STAGE2_SCHEDULE_APPLICANT_ACCEPTED" && (
                                          <>
                                            <div className="mt-2 ">
                                              <label>Venue and Contact Details</label> : {" "}
                                              <span
                                                className="link link-primary emp-appl-custom-link"
                                                name="status"
                                                onClick={showVenueDetails.bind(this, el, true)}
                                                tabIndex={0}
                                                onKeyDown={(e) => { }}
                                              >
                                                View Venue & Contact Details
                                              </span>
                                            </div>
                                            <lable>Action Required </lable> : {" "}
                                          </>
                                        )}
                                        <span
                                          className="link link-primary emp-appl-custom-link"
                                          name="status"
                                          onClick={getSavedData.bind(this, el, true)}
                                          tabIndex={0}
                                          onKeyDown={(e) => {
                                            if (e.key !== "Tab" && ERPUtils.isKeyBoardEnterPressed(e)) getSavedData(el, true);
                                          }}
                                        >
                                          Click here to fill additional information to application
                                        </span>
                                      </>
                                    )
                                      : el.applicantProcessCode === "EMP_STAGE1_HOD_RESCHEDULED" && el.applicationProcessCode === "EMP_STAGE1_HOD_RESCHEDULED" ?
                                        (
                                          <div className="">
                                            <span
                                              className="link link-primary emp-appl-custom-link pb-2 d-flex"
                                              name="status"
                                              onClick={CallRoundDetailsApi.bind(this, el, true)}
                                              tabIndex={0}
                                              onKeyDown={(e) => {
                                                if (e.key !== "Tab" && ERPUtils.isKeyBoardEnterPressed(e)) CallRoundDetailsApi(el, true);
                                              }}
                                            >
                                              {el.applicantCurrentProcessStatus}
                                            </span>
                                            <span
                                              className="link link-primary emp-appl-custom-link"
                                              name="status"
                                              onClick={getSavedData.bind(this, el, true)}
                                              tabIndex={0}
                                              onKeyDown={(e) => {
                                                if (e.key !== "Tab" && ERPUtils.isKeyBoardEnterPressed(e)) getSavedData(el, true);
                                              }}
                                            >
                                              Click here to fill additional information to application
                                            </span>
                                          </div>
                                        ) : el.applicantProcessCode === "EMP_STAGE2_PO_RESCHEDULED" && el.applicationProcessCode === "EMP_STAGE2_PO_RESCHEDULED" ? (
                                          <div className="">
                                            <span
                                              className="link link-primary emp-appl-custom-link pb-2 d-flex"
                                              name="status"
                                              onClick={CallRoundDetailsApi.bind(this, el, true)}
                                              tabIndex={0}
                                              onKeyDown={(e) => {
                                                if (e.key !== "Tab" && ERPUtils.isKeyBoardEnterPressed(e)) CallRoundDetailsApi(el, true);
                                              }}
                                            >
                                              {el.applicantCurrentProcessStatus}
                                            </span>
                                            <span
                                              className="link link-primary emp-appl-custom-link"
                                              name="status"
                                              onClick={getSavedData.bind(this, el, true)}
                                              tabIndex={0}
                                              onKeyDown={(e) => {
                                                if (e.key !== "Tab" && ERPUtils.isKeyBoardEnterPressed(e)) getSavedData(el, true);
                                              }}
                                            >
                                              Click here to fill additional information to application
                                            </span>
                                          </div>
                                        ) :
                                          el.applicantProcessCode === "EMP_STAGE3_SCHEDULE_APPLICANT_ACCEPTED" ? (
                                            <>
                                              <p>{el.applicantCurrentProcessStatus}</p>
                                              <div className="mt-2 ">
                                                <label>Venue and Contact Details</label> : {" "}
                                                <span
                                                  className="link link-primary emp-appl-custom-link"
                                                  name="status"
                                                  onClick={showVenueDetails.bind(this, el, true)}
                                                  tabIndex={0}
                                                  onKeyDown={(e) => { }}
                                                >
                                                  View Venue & Contact Details
                                                </span>
                                              </div>
                                            </>
                                          ) : <p>{el.applicantCurrentProcessStatus}</p>}

                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* For showing venue details  */}

      <Dialog open={isShowVenue} maxWidth="md">
        <DialogContent className="m-auto">
          <div className=" d-flex justify-content-end align-items-center pr-2">
            <button className="PreviewRemoveButton" type="button" onClick={() => setIsShowVenue(false)}>
              &times;
            </button>
          </div>
          <InterviewScheduleDetails interviewDetails={interviewDetails} />
        </DialogContent>
      </Dialog>


      <Dialog open={interviewModal} maxWidth={"lg"} fullWidth={true}>
        <DialogContent style={{ padding: "9px" }}>
          <div className="InterivewRoundsPopupHeader d-flex justify-content-end align-items-center pr-2" style={{ height: '8%' }}>
            <div className="p-2">
              <button className="PreviewRemoveButton" type="button" onClick={closeInterviewModal}>
                &times;
              </button>
            </div>
          </div>
          <div className="InterivewRoundsPopupBody">
            {CompState.FirstRound ? (
              <FirstRound
                interviewDetails={interviewDetails}
                workFlow={workFlow}
                ActiveInterviewRound={ActiveInterviewRound}
                closeInterviewModal={closeInterviewModal}
                ApplicationsPrevData={ApplicationsPrevData}
                getApplicationsData={getApplicationsData}
                savedData={savedData}
              />
            ) : null}
            {CompState.SecondRound ? (
              <SecondRound
                interviewDetails={interviewDetails}
                ActiveInterviewRound={ActiveInterviewRound}
                ApplicationsPrevData={ApplicationsPrevData}
                closeInterviewModal={closeInterviewModal}
                getApplicationsData={getApplicationsData}
                savedData={savedData}
              />
            ) : null}
            {CompState.ThirdRound ? (
              <ThirdRound
                interviewDetails={interviewDetails}
                ActiveInterviewRound={ActiveInterviewRound}
                closeInterviewModal={closeInterviewModal}
                getApplicationsData={getApplicationsData}
                savedData={savedData}
              />
            ) : null}
            {CompState.selected ? (
              <SelectedForm
                interviewDetails={interviewDetails}
                ActiveInterviewRound={ActiveInterviewRound}
                selectedRoundData={selectedRoundData}
                getApplicationsData={getApplicationsData}
                closeInterviewModal={closeInterviewModal}
              />
            ) : null}
          </div>
        </DialogContent>
      </Dialog>

      {ModalOpen ? <ApplicationPreview open={ModalOpen} close={handleClose} previewData={previewData} getDob={getDob} /> : null}

      {
        ApiError ? (
          <Popup
            open={ApiError}
            close={closeErrorPopup}
            msg="Error! occourred while loading the data."
            title="Sorry! for the inconvenience occourred. Please try again"
            icon={<i className="fa fa-times-circle" style={{ fontSize: "48px", color: "#D9291B" }} />}
            success={false}
            tabName=""
          />
        ) : null
      }
      {
        archiveMsg ? (
          <Popup
            open={archiveMsg}
            close={() => setArchivedMsg(false)}
            msg="Please contact HR for details."
            title="Unable to process your request as the status of your application is changed"
            icon={<i className="fa fa-times-circle" style={{ fontSize: "48px", color: "#D9291B" }} />}
            success={false}
            tabName=""
          />
        ) : null
      }

      {
        refreshFlag && (
          <Popup
            open={refreshFlag}
            close={refreshWindowCell}
            msg="You've already moved forward to the next stage."
            title="Sorry! for the inconvenience"
            // icon={<i className="fa fa-times-circle" style={{ fontSize: "48px", color: "#D9291B" }} />}
            success={true}
            tabName=""
          />
        )
      }

      {LoaderActive ? <Loader open={LoaderActive} LoaderType={1} /> : null}
    </div >
  );
};

export default Dashboard;
